import {
  Button,
  Checkbox,
  Input,
  PasswordRequirements,
  useI18n,
} from '@nosinovacao/nosid-mfe-common';
import { type NewPasswordProps } from '../-model/props';

export function NewPasswordLight({
  form,
  isPending,
  requirements,
  logoutAllDevices,
  onLogoutAllDevicesChange,
  onSubmit,
}: Readonly<NewPasswordProps>) {
  const { t } = useI18n();
  return (
    <form
      className="flex h-full flex-col gap-6"
      onSubmit={form.handleSubmit(onSubmit)}
      data-tid="form-new-password"
    >
      <div className="flex flex-col gap-4">
        <Input
          skin="light"
          id={form.ids.password ?? 'new-password'}
          type="password"
          label={t('Home.NewPassword.Label')}
          value={form.value.password}
          onChange={(e) => form.setValue('password', e.target.value)}
          errors={form.errors.password}
          password-button-show-aria-label={t('Common.Password.Show')}
          password-button-hide-aria-label={t('Common.Password.Hide')}
          data-tid="input-new-password"
          autoFocus
        />
        {requirements && (
          <PasswordRequirements
            skin="light"
            id="password-requirements"
            requirements={requirements}
            translationKey="Common.PasswordWidget"
            value={form.value.password}
          />
        )}
      </div>
      <div className="mt-auto flex flex-col gap-6 pb-4">
        <div className="flex cursor-pointer items-center gap-3">
          <Checkbox
            id="logout-all-devices"
            skin="light"
            checked={logoutAllDevices}
            onChange={onLogoutAllDevicesChange}
            data-tid="checkbox-logout-all-devices"
          />
          <span className="cursor-pointer font-ui-9" data-tid="text-logout-all-devices">
            {t('Home.NewPassword.LogoutAllDevices')}
          </span>
        </div>
        <Button
          skin="light"
          variant="primary"
          className="w-full tablet:w-fit"
          type="submit"
          disabled={isPending || !form.value.password}
          data-tid="button-submit-new-password"
        >
          {t('Home.NewPassword.Button')}
        </Button>
      </div>
    </form>
  );
}
